export default __webpack_public_path__ + "assets/ec4da9dd58cd9134bc97bbeb524d39ea.png";